const getDisclosures = (state) => (state && state.disclosures && state.disclosures.disclosures) || {};
const isFetchingDisclosures = (state) => (state && state.disclosures && state.disclosures.isFetching) || false;
const getDisclosuresError = (state) => (state && state.disclosures && state.disclosures.error) || null;

export default {
    getDisclosures,
    isFetchingDisclosures,
    getDisclosuresError
};
